//I18n
import Translate from '../../i18n/Translate';

//Intersection
import { useInView } from "react-intersection-observer";

const OurEssence = () => {

    const [title, inView] = useInView({
        triggerOnce: true,
        threshold: .5
    });

    const [copy, inView2] = useInView({
        triggerOnce: true,
        threshold: .1
    });

    return (
        <section className="incoming-about__our-essence" >

            <h2 className={`title animate slide-up ${inView ? 'in-view': ''}`} ref={title}>
                <Translate langkey="about.our_essence.title" />
            </h2>

            <div className={`copy animate slide-up ${inView2 ? 'in-view': ''}`} ref={copy}>
                <p>
                    <Translate langkey="about.our_essence.copy1" />
                </p>
                <p>
                    <Translate langkey="about.our_essence.copy2" />
                </p>
                <p>
                    <Translate langkey="about.our_essence.copy3" />
                </p>
                <p>
                    <Translate langkey="about.our_essence.copy4" />
                </p>
                <p>
                    <Translate langkey="about.our_essence.copy5" />
                </p>
            </div>
            
        </section>
    )
}

export default OurEssence
